// src/components/ui/Icons.js
// Lightweight stroke icons (Lucide-style) used across the site.
// All inherit `currentColor`; size via the `size` prop or CSS.
import React from 'react';

const base = (size = 24) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  xmlns: 'http://www.w3.org/2000/svg',
});

export const IconCheck = ({ size }) => (
  <svg {...base(size)}><path d="M20 6 9 17l-5-5" /></svg>
);

export const IconArrowRight = ({ size }) => (
  <svg {...base(size)}><path d="M5 12h14M12 5l7 7-7 7" /></svg>
);

export const IconEdit = ({ size }) => (
  <svg {...base(size)}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

export const IconCalendar = ({ size }) => (
  <svg {...base(size)}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

// Product / feature glyphs
export const IconChef = ({ size }) => (
  <svg {...base(size)}>
    <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" />
    <path d="M6 17h12" />
  </svg>
);

export const IconTarget = ({ size }) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export const IconChart = ({ size }) => (
  <svg {...base(size)}>
    <path d="M3 3v18h18" />
    <path d="M18 17V9M13 17V5M8 17v-3" />
  </svg>
);

export const IconStethoscope = ({ size }) => (
  <svg {...base(size)}>
    <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .2.3" />
    <path d="M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4" />
    <circle cx="20" cy="10" r="2" />
  </svg>
);

export const IconWave = ({ size }) => (
  <svg {...base(size)}><path d="M2 12h2M7 6v12M12 3v18M17 6v12M20 10v4" /></svg>
);
